import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20dreamy%20comic%20reading%20environment%2C%20soft%20warm%20gradients%20of%20amber%20and%20rose%2C%20abstract%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20gentle%20particles%20drifting%20upward%2C%20minimalist%20aesthetic%2C%20warm%20atmospheric%20lighting%2C%20digital%20art%20with%20soft%20edges%2C%20cinematic%20composition%2C%20no%20text%2C%20serene%20mood&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫之家 - 韩国漫画在线观看平台"
        title="韩漫之家 - 海量正版韩漫资源"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <h1 className="font-display text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            韩漫之家
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            海量正版韩漫资源 · 下拉式沉浸阅读 · 高清画质 · 极速更新
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-medium text-sm hover:bg-white/30 transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1">
        <span className="text-white/50 text-xs">向下滚动探索</span>
        <i className="ri-arrow-down-s-line text-white/50 animate-bounce"></i>
      </div>
    </section>
  );
}